import { render } from "./WuliuSer.vue?vue&type=template&id=057a1bf0&scoped=true"
import script from "./WuliuSer.vue?vue&type=script&lang=js"
export * from "./WuliuSer.vue?vue&type=script&lang=js"

import "./WuliuSer.vue?vue&type=style&index=0&id=057a1bf0&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057a1bf0"]])

export default __exports__